import {
  ErrorBoundary,
  IcpFooter,
  Layout,
  RouteScrollRestoration,
  TenantWatermark,
} from '@/components';
import { destroyMobileOverlays } from '@/mobile-ui';
import { type ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AppRouter from './AppRouter';

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <>
      <Layout>{children}</Layout>
      <IcpFooter />
    </>
  );
}

export default function App() {
  const location = useLocation();

  // 路由改变，关闭所有弹框
  useEffect(() => {
    destroyMobileOverlays();
  }, [location]);

  return (
    <ErrorBoundary>
      <RouteScrollRestoration />
      <TenantWatermark>
        <AppShell>
          <AppRouter />
        </AppShell>
      </TenantWatermark>
    </ErrorBoundary>
  );
}
